import VueApollo                        from 'vue-apollo'
import { ApolloClient }                 from 'apollo-client'
import { HttpLink }                     from 'apollo-link-http'
import { setContext }                   from 'apollo-link-context'
import { InMemoryCache }                from 'apollo-cache-inmemory'
import { onError }                      from 'apollo-link-error'
import { ApolloLink, split }            from 'apollo-link'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { hasSubscription }              from "@jumpn/utils-graphql"
import SocketLink                       from './socketLink.js'
import gql from 'graphql-tag'


const httpLink =
  new HttpLink ({
    uri: '/api',
    credentials: 'same-origin'
  })

const middlewareLink = setContext(() => ({
  headers: {
    auth: localStorage.getItem('cardstock_auth_token')
  }
}))

const errorLink = onError(({ operation, response, graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      console.info(message)
      console.warn(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
      )
      console.info(response)
    });
  if (networkError) console.warn(`[Network error]: ${networkError}`);
})

const link = ApolloLink.from([
  middlewareLink,
  // errorLink,
  httpLink
])

const socketLink = ApolloLink.from([
  errorLink,
  SocketLink
])

const splitLink = split(
  operation => hasSubscription(operation.query),
  SocketLink,
  link
)

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: "UNION",
          name: "Communication",
          possibleTypes: [
            { name: "PhoneCall" },
            { name: "Message" },
          ],
        },
        {
          kind: "UNION",
          name: "ProvisionalGradeLevel",
          possibleTypes: [
            { name: "GradeLevel" },
            { name: "ProvisionalNewGradeLevel" },
          ],
        },
        {
          kind: "UNION",
          name: "ProvisionalHomeLanguage",
          possibleTypes: [
            { name: "HomeLanguage" },
            { name: "ProvisionalRejectedHomeLanguage" },
          ],
        },
        {
          kind: "UNION",
          name: "ProvisonalHomeNumber",
          possibleTypes: [
            { name: "ProvisionalNewHomeNumber" },
            { name: "ProvisionalUpdatedHomeNumber" },
            { name: "ProvisionalRejectedHomeNumber" },
          ],
        },
        {
          kind: "UNION",
          name: "ProvisionalStudent",
          possibleTypes: [
            { name: "ProvisionalNewStudent" },
            { name: "ProvisionalUpdatedStudent" }
          ],
        },
      ],
    },
  }
})


const resolvers = {
  Query: { online: () => false }
};

const typeDefs = gql`
  extend type Query {
    online: Boolean!
  }`

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    link: splitLink,
    // link: socketLink,
    cache: new InMemoryCache({fragmentMatcher}),
    typeDefs,
    resolvers,
    connectToDevTools: true,
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only'
      }
    }
  })
})

export default apolloProvider
